import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../analytics/ga";

export const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);

    const params = new URLSearchParams(location.search);
    const utmSource = params.get("utm_source");
    if (utmSource) {
      localStorage.setItem("utm_source", utmSource);
    }
  }, [location.pathname, location.search]);
};
